import { render, staticRenderFns } from "./author.vue?vue&type=template&id=c078068c"
import script from "./author.vue?vue&type=script&lang=ts"
export * from "./author.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports